import { Tooltip } from "@material-ui/core";
import { observer } from "mobx-react-lite";
import React, { useState, useRef, useEffect } from "react";
import EventLabel from "../../components/EventLabel";


export const SubmitButton = observer((props) => {
  const [disableButton, setDisableButton] = useState(false);
  const { validations, register, environment, settings, current, triggerValidation, activePersonNo, orders, checkInvoiceValidation, getFilteredValidations, grpRegDisabled = false } = props;
  const { texts } = settings;
  const registerCallbackRef = useRef();
  let isValid = getFilteredValidations() == 0;

  useEffect(() => {
    registerCallbackRef.current = registerCallback;
    // props.checkMainEventBookingStatus()
  })
  useEffect(() => {
    if (props.mainEventFullbooked && !disableButton) {
      setDisableButton(true);
    }
  }, [props?.mainEventFullbooked])
  const registerCallback = () => {
    setDisableButton(false);
  }
  return (
    <Tooltip
      title={<EventLabel name="GroupRegMinCountValidationMessage" groupName="CMS.GROUPMODULE" textOnly={true} />}
      disableHoverListener={!grpRegDisabled}
    >
        <button
          className="cms-button"
          disabled={disableButton}
          onClick={() => {
            //this code is repeated in 3 modules, change it
            if (isValid) {
              if (!grpRegDisabled) {
                register(() => registerCallbackRef.current());
                setDisableButton(true);
              }
            } else {
              triggerValidation();
            }
          }}
        >
          {texts ? texts[environment.lang] : settings.register[environment.lang]}
        </button>
    </Tooltip>

  );
});
